import { api } from "@/lib/api";
import { toast } from "sonner";

export async function startCheckout(packageId, { onUnauthenticated } = {}) {
  try {
    const r = await api.post("/payments/checkout", {
      package_id: packageId,
      origin_url: window.location.origin,
    });
    if (r.data?.url) {
      window.location.href = r.data.url;
    } else {
      toast.error("Could not start checkout.");
    }
  } catch (e) {
    if (e.response?.status === 401) {
      if (onUnauthenticated) onUnauthenticated();
      else window.location.href = `/auth?mode=signup&next=${encodeURIComponent("/pricing")}`;
      return;
    }
    toast.error(e.response?.data?.detail || "Checkout failed");
  }
}
